import { RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot, hydrateRoot } from "react-dom/client"
import { makeRouter } from "./App.js"
import "./styles.css"

const rootElement = document.getElementById("root")
if (rootElement === null) throw new Error("missing #root")

const router = makeRouter()
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)

// A prerendered page (scripts/prerender.mjs) arrives with the route already in
// the root element; the router loads the same match (loader data and the split
// component chunk) before hydrating so the first client render is the server's.
// The dev server and any un-prerendered shell take the plain client mount.
if (rootElement.hasChildNodes()) {
  // Mark the router as server-rendered. This is the field the SSR client's
  // hydrate() sets; it makes the match tree take the same shape the prerender
  // produced (no client-only Suspense boundary at the root, whose markers the
  // prerendered HTML does not carry). There is no dehydrated state here: the
  // loaders simply run again before hydration.
  router.ssr = { manifest: undefined }
  await router.load()
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
